import { useState, useEffect } from "react";
import Config from "../../Config";


function Start(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);




    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }



    


    return <div>
        start {refreshView}
    </div>
}


export default Start;